import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addWeeks,
  addYears,
  differenceInMonths,
  endOfDay,
  startOfDay,
  startOfMonth,
  startOfYear,
} from "date-fns";

export const midday = (date: Date) => addHours(startOfDay(date), 12);

export const intervalToTimeRange = (
  interval: IntervalType,
  startDate?: Date,
  endDate?: Date
) => {
  if (interval === "oneDay") {
    return {
      startDate: startOfDay(new Date()),
      endDate: endOfDay(new Date()),
    };
  }

  if (interval === "oneWeek") {
    return {
      startDate: midday(addWeeks(new Date(), -1)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "oneMonth") {
    return {
      startDate: midday(addMonths(new Date(), -1)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "sixMonths") {
    return {
      startDate: midday(addMonths(new Date(), -6)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "oneYear") {
    return {
      startDate: midday(addYears(new Date(), -1)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "twoYears") {
    return {
      startDate: midday(addYears(new Date(), -2)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "threeYears") {
    return {
      startDate: midday(addYears(new Date(), -3)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "fiveYears") {
    return {
      startDate: midday(addYears(new Date(), -5)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "YTD") {
    return {
      startDate: midday(startOfYear(new Date())),
      endDate: midday(new Date()),
    };
  }
  if (interval === "14days") {
    return {
      startDate: midday(addDays(new Date(), -14)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "30days") {
    return {
      startDate: midday(addDays(new Date(), -30)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "60days") {
    return {
      startDate: midday(addDays(new Date(), -60)),
      endDate: midday(new Date()),
    };
  }
  if (interval === "currentYear") {
    const year = new Date().getFullYear();
    return {
      startDate: midday(new Date(year, 0, 1)),
      endDate: midday(new Date(year + 1, 0, 1)),
    };
  }

  if (interval === "sinceBeginning") {
    return {
      startDate: midday(addYears(new Date(), -100)),
      endDate: midday(new Date()),
    };
  }

  if (interval === "all") {
    return {
      startDate: undefined,
      endDate: midday(new Date()),
    };
  }

  if (interval === "custom" && startDate && endDate) {
    return {
      startDate,
      endDate,
    };
  }

  throw new Error(`Unknown interval: ${interval}`);
};

export const getDateInterval = (startDate?: Date, endDate?: Date) => {
  if (!startDate && !!endDate) return "week";
  if (!startDate) return "day";
  if (!endDate) return "day";
  const monthDiff = differenceInMonths(endDate, startDate);
  if (monthDiff > 12) return "week";
  return "day";
};

export const startDate = (currentDate = new Date()) =>
  startOfMonth(addMonths(addDays(currentDate, 25), 1));

export const sameDateInUTC = (date: Date) =>
  addMinutes(
    date,
    -date.getTimezoneOffset() // it fixes timezone for saving to backend as date-fns calculates always in local timezone
  );

export const startDateUTC = (currentDate = new Date()) =>
  sameDateInUTC(startDate(currentDate));
